import React from "react";
import { Volume2, VolumeX } from "lucide-react";
import { COLORS } from "../constants";
import { pill, fontSerif } from "./styles";

export default function AudioControls({ muted, setMuted, volume, setVolume }) {
  const toggleMute = () => setMuted(!muted);

  return (
    <div
      data-testid="zone-audio-controls"
      style={{
        position: "absolute",
        bottom: 22,
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        alignItems: "center",
        gap: 10,
        ...pill,
        padding: "8px 14px",
        pointerEvents: "auto",
        color: COLORS.ivory,
        fontFamily: fontSerif,
      }}
    >
      <button
        data-testid="zone-audio-mute"
        onClick={toggleMute}
        aria-pressed={muted}
        title={muted ? "Unmute bell" : "Mute bell"}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: muted ? "#c08070" : COLORS.gold,
          display: "flex",
          alignItems: "center",
          padding: 2,
        }}
      >
        {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
      </button>
      <div
        style={{
          fontSize: 10,
          letterSpacing: 2.5,
          textTransform: "uppercase",
          color: COLORS.gold,
          whiteSpace: "nowrap",
        }}
      >
        Bell
      </div>
      <input
        data-testid="zone-audio-volume"
        type="range"
        min={0}
        max={1}
        step={0.05}
        value={muted ? 0 : volume}
        disabled={muted}
        onChange={(e) => {
          const v = parseFloat(e.target.value);
          if (muted && v > 0) setMuted(false);
          setVolume(v);
        }}
        style={{
          width: 110,
          accentColor: COLORS.gold,
          cursor: muted ? "not-allowed" : "pointer",
          opacity: muted ? 0.4 : 1,
        }}
      />
      <div
        data-testid="zone-audio-percent"
        style={{
          fontSize: 11,
          color: COLORS.ivory,
          opacity: 0.85,
          minWidth: 32,
          textAlign: "right",
          fontVariantNumeric: "tabular-nums",
        }}
      >
        {muted ? "—" : `${Math.round(volume * 100)}%`}
      </div>
    </div>
  );
}
